<template>
  <div class="debt-report">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-date"></i> Debt Report</span>
        <el-button icon="el-icon-download" v-if="Object.keys(waitlist).length > 0" style="float: right;"  type="success" @click="Report()">Export</el-button>
      </div>

        
        <el-tabs type="card" v-model="debtNameTap">
          <el-tab-pane v-for="currency in Object.keys(waitlistSum)" :key="currency" :label="`${currency.toUpperCase()} ${waitlistSum[currency].amountFormat}`" :name="currency">
            <data-tables
            v-loading="loading"  
              :data="waitlist[currency]" 
              border 
              :page-size="20"
              :pagination-props="{ background: true, pageSizes: [20, 50, 100, 200] }">
              <el-table-column prop="addDate" label="Add Date" header-align="center" align="center"> </el-table-column>
              <el-table-column prop="paidDate" label="Paid Date" header-align="center" align="center"> </el-table-column>
              <el-table-column prop="member_code" label="Member Code" header-align="center" align="center"> </el-table-column>
              <el-table-column prop="bankholderId" label="BankholderID" header-align="center" align="center"> </el-table-column>
              <el-table-column prop="description" label="Description" header-align="center" align="center"> </el-table-column>
              <el-table-column prop="status" label="Status" header-align="center" align="center"> </el-table-column>
              <el-table-column prop="amountFormat" label="Amount" header-align="center" align="center"> </el-table-column>
              <el-table-column prop="uid" label="Action" header-align="center" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="showDetail(scope.row)">View</el-button>
                </template>
              </el-table-column>
   
            </data-tables>
          </el-tab-pane>
        </el-tabs>
    </el-card>

    <el-dialog
      title="Debt Detail"
      :visible.sync="dialogVisible"
      :width="device === 'mobile' ? '95%' : '70%'"
      top="5vh">
       <el-row :gutter="10" v-if="debtDetail">
        <el-col :xs="24" :sm="24" :md="24" :lg="12">
          <el-form
                label-width="100px"
                size="small"
                :label-position="device === 'mobile' ? 'left' : 'right'"
              >
              <el-form-item label="Add Date">
                {{ debtDetail.addDate }}
              </el-form-item>
              <el-form-item label="Amount">
                {{ debtDetail.amountFormat }}
              </el-form-item>
              <el-form-item label="Description">
                {{ debtDetail.description }}
              </el-form-item>
              <el-form-item label="Paid Date">
                {{ debtDetail.paidDate }}
              </el-form-item>
              <el-form-item label="Status">
                {{ debtDetail.status }}
              </el-form-item>



          </el-form>

        </el-col>

        <el-col :xs="24" :sm="24" :md="24" :lg="12">

          <h4>Transaction Detail</h4>
          <pre v-html="detailRender(debtDetail.meta)"></pre>

        </el-col>

       </el-row>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">Close</el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
import { getDebtCustomerSummary, getDebtCustomerList, getDebtCustomerExport } from '@/api/debt'
import { getCustomerBy } from '@/api/customer'
export default {
  props:{
    customerUID: String
  },
  computed:{
    device() {
      return this.$store.state.app.device;
    }
  },
  data(){
    return {
      dialogVisible: false,
      debtNameTap: "",
      waitlist: {},
      waitlistSum: {},
      debtDetail: null,
      loading: false,
      endUserId: ""
    }
  },
  methods:{
    getCustomerInfo() {
      getCustomerBy(this.customerUID).then(({ result, data }) => {
        if (result && data) {
          this.endUserId = data.enduser_id
          this.queryInit();
        }
      });
    },
    getWaitlist(){
      
      getDebtCustomerList(this.endUserId).then(({result, data})=>{
        if(result){
          this.waitlist = data
          this.debtNameTap = Object.keys(data)[0] || ""
        }
      })
    },
    getWaitlistSummary(){
      this.loading = true
      getDebtCustomerSummary(this.endUserId).then(({result, data})=>{
        this.loading = false
        if(result){
          this.waitlistSum = data ? data.currency : {}
        }
      })
    },
    showDetail(meta){
      this.debtDetail = meta
      this.dialogVisible = true
    },
    detailRender(data){
      if(!data) return "";
      let detail = []
      Object.keys(data).forEach(key => {
        
        let element = data[key]
        if(typeof element === 'object'){
          let subdetail = []

          Object.keys(element).forEach(keysub => {
            let elementsub = element[keysub]
            subdetail.push(`<b>${key}_${keysub}</b>: <code>${elementsub}</code>`)
          })

          detail.push(`${subdetail.join('\n')}`)
        
        }else{
          detail.push(`<b>${key}</b>: <code>${element}</code>`)
        }
      });

      return detail.join('\n');
    },
    Report(){
      getDebtCustomerExport(this.endUserId)
    },

    queryInit(){
      this.waitlist = {}
      this.waitlistSum = {}
      this.getWaitlistSummary()
      this.getWaitlist()
    }
  },
  created(){
   this.getCustomerInfo()
  }
}
</script>

<style lang="scss">
.debt-report{
  .query-area{
    margin-bottom: 10px;
  }
  
  code {
    color: #408fff;
    background-color: #e6effb;
    margin: 0 4px;
    display: inline-block;
    padding: 1px 5px;
    font-size: 14px;
    border-radius: 3px;
    height: 18px;
    line-height: 18px;
  }

  pre{
    white-space: pre-line;
    line-height: 30px;
  }
}
</style>